export default function moderationModal(projectId, ids = []) {
  return {
    open: false,
    projectId: projectId,
    ids: ids,
    currentId: null,
    prevId: null,
    nextId: null,

    init() {
      this.spinnerEl = this.$root.querySelector('#spinner').outerHTML;
      this.$watch(
        () => this.currentId,
        () => {
          this.prevId = this.getPreviousId();
          this.nextId = this.getNextId();
        }
      );
    },

    openModal() {
      this.open = true;
    },

    closeModal() {
      this.open = false;
      if (this.spinnerEl) {
        this.$root.querySelector('#moderation-modal__entry-frame').innerHTML = this.spinnerEl;
      }
    },

    getNextId() {
      const currentIndex = this.ids.indexOf(this.currentId);
      return this.ids[currentIndex + 1] || null;
    },

    getPreviousId() {
      const currentIndex = this.ids.indexOf(this.currentId);
      return this.ids[currentIndex - 1] || null;
    },
  };
}
